// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3RGZt","footer":"ModalCreateQualiphyProcedure_footer__3Pzww","additionData":"ModalCreateQualiphyProcedure_additionData__2HU8o"};